import { POST, GET, PUT, DELETE } from '../request'

export const crearEvento = evento =>
  POST('/api/agora/interno/eventos-calendario', evento)

export const getEventos = ({ mes, centro }) =>
  GET('/api/agora/interno/eventos-calendario/list', { mes, centro })
export const getEventosHoy = () =>
  GET('/api/agora/interno/eventos-calendario/list/today')

export const actualizarEvento = evento =>
  PUT('/api/agora/interno/eventos-calendario', evento)

export const borrarEvento = id =>
  DELETE('/api/agora/interno/eventos-calendario', { id })
